import NotAuthHeader from "../components/not-auth-header";
import React, {useEffect, useState} from "react";
import NotAuthWrapper from "../components/not-auth-wrapper";
import {Grid} from "@mui/material";
import styled from "styled-components";
import {Colors} from "../theme/colors";
import {StyledH3, StyledH5, StyledP1} from "../components/ui-base/styles";
import {Link, useParams} from "react-router-dom";
import {StyledButton} from "../components/ui-base/button";
import {useTranslation} from "react-i18next";
import CircularProgress from "@mui/material/CircularProgress";
import {AuthService} from "../services/auth.service";
import {showSnackError} from "../store/global/global-slice";
import {useDispatch} from "react-redux";


export const ConfirmEmailPage = () => {
    const [accountActivated, setAccountActivated] = useState(false);
    const dispatch = useDispatch();
    const urlParams = useParams();
    const uid: string = urlParams['uid'] as string;
    const token: string = urlParams['token'] as string;
    const { t } = useTranslation('common');



    useEffect(() => {
         const activeAccount = async () => {
            const res = await AuthService.activeEmail(uid, token);
             if (res) {
                 setAccountActivated(true);
             }
        }

        if (uid && token) {
            activeAccount();
        } else {
            dispatch(showSnackError(t('emailConfirm.wrongUrl')));
        }
    }, [uid, token]);

    return (
        <NotAuthWrapper children={
            <>
                <NotAuthHeader/>
                <Grid item container direction="column" justifyContent="center" alignItems="center" xs>
                    <StyledConfirmEmailContainer>
                        {!accountActivated &&
                            <>
                                <StyledH5 style={{textAlign: 'center'}} color={Colors.neutral10}>{t('emailConfirm.activatingTitle')}</StyledH5>

                                <StyledLoader>
                                    <CircularProgress size={60} />
                                </StyledLoader>
                            </>
                        }
                        
                        {accountActivated && 
                            <>
                                <StyledH3 style={{textAlign: 'center'}} color={Colors.neutral10}>{t('emailConfirm.successTitle')}</StyledH3>

                                <Grid item container direction="row" justifyContent="center">
                                    <Link to={'/login'}>
                                        <StyledButton type="submit" color={'primary'}>
                                            {t('emailConfirm.successButton')}
                                        </StyledButton>
                                    </Link>
                                </Grid>       
                            </>
                        }
                    </StyledConfirmEmailContainer>
                </Grid>
            </>
        }/>
    )
}

const StyledConfirmEmailContainer = styled(Grid)`
  border-radius: 32px;
  border: 1px solid ${Colors.secondary95};
  background: ${Colors.neutral98};
  width: 450px;
  padding: 2rem;
  
  ${StyledP1}, ${StyledH3} {
    text-align: center;
    margin-bottom: 1.5rem;
  }
`;

const StyledLoader = styled('div')`
  width: 60px;
  margin: 2rem auto 0;
  
  svg {
    color: ${Colors.secondary50};
  }
`